"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StreetViewSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M12,18h1.11l.78,7A1.15,1.15,0,0,0,15,26h2a1.15,1.15,0,0,0,1.11-1l.78-7H20a1.5,1.5,0,0,0,1.53-1.94L20,10a3,3,0,0,0-2.2-2.25l-.51,0a3,3,0,1,0-2.58,0l-.51,0A3,3,0,0,0,12,10l-1.53,6.06A1.5,1.5,0,0,0,12,18Z"/><path d="M21.42,22.31l-.22,2A18.26,18.26,0,0,1,27.66,26c-1.35.83-5.39,2-11.66,2S5.69,26.83,4.34,26a18.26,18.26,0,0,1,6.46-1.71l-.22-2C5.54,22.92,2,24.34,2,26c0,2.21,6.27,4,14,4s14-1.79,14-4C30,24.34,26.46,22.92,21.42,22.31Z"/>';
var StreetViewSVG = function StreetViewSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.StreetViewSVG = StreetViewSVG;
StreetViewSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(StreetViewSVG);
exports.default = _default;